import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
} from './club-attachment.action';
import { ClubAttachment } from './club-attachment.model';

export interface ClubAttachmentRecordsState {
    listData: any[];
    singleData: ClubAttachment;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: ClubAttachmentRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
};


export const clubAttachmentRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData: listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
);